var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.permissions.length)?_c('div',{staticClass:"container-fluid border border-0 p-0 d-flex flex-column",staticStyle:{"min-height":"100vh"}},[_c('div',{staticClass:"container-fluid p-0"},[_c('header-bar')],1),_c('div',{staticClass:"border-0 px-3",attrs:{"id":"main-content"}},[_c('router-view')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }